export default "__VITE_ASSET__1e99kYR6__"